import { RetentionItem } from "interface/admin/interface.dashboard";
import {
  XAxis,
  YAxis,
  CartesianGrid,
  ResponsiveContainer,
  LineChart,
  Tooltip,
  Line,
} from "recharts";
import { ChartBox, ChartItemWrap } from "style/admin/dashboard";

interface DataProps {
  data: RetentionItem[];
  userTotalCount: number;
}
interface AccumulatedItem {
  label: string;
  value: number;
  __sum: number; // 내부 누적용 필드
}

const DashboardChartLine = ({ data, userTotalCount }: DataProps) => {
  const displayedData = [...data]
    .reverse() // 최신 날짜부터 뒤에서부터 누적합
    .reduce<AccumulatedItem[]>((acc, item, idx) => {
      const prevSum = acc[idx - 1]?.__sum || 0;
      const currentSum = prevSum + item.userCount;

      acc.push({
        label: item.date,
        value: userTotalCount - currentSum,
        __sum: currentSum, // 내부용 누적값
      });

      return acc;
    }, [])
    .reverse() // 다시 날짜 순서대로 정렬
    .map(({ label, value }) => ({ label, value })); // __sum 제거

  return (
    <ChartBox>
      <ChartItemWrap>
        <h4>User Retention (~Day 10)</h4>
        <ResponsiveContainer width="100%" height={300}>
          <LineChart
            data={displayedData}
            margin={{ top: 20, right: 30, left: -30, bottom: 0 }}
          >
            <CartesianGrid strokeDasharray="0 3" />
            <XAxis dataKey="label" tickMargin={10} />
            <YAxis
              domain={[0, Math.ceil(userTotalCount * 1.1)]}
              tick={{ fontSize: 12 }}
            />
            <Tooltip
              formatter={(value: number) => [`${value}명`, "회원수"]}
              contentStyle={{ fontSize: "12px" }}
            />
            <Line
              type="monotone"
              dataKey="value"
              stroke="#5B93FF"
              strokeWidth={2}
              dot={{ r: 4 }}
              activeDot={{ r: 6 }}
            />
          </LineChart>
        </ResponsiveContainer>
      </ChartItemWrap>
    </ChartBox>
  );
};

export default DashboardChartLine;
